module.exports = __webpack_public_path__ + "static/img/14000119.07f89d1b.png";